import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ResponseTutor, Tutor } from 'src/app/model/Tutor.model';
import { StorageService } from 'src/app/service/storage.service';
import { TutorService } from 'src/app/service/tutor.service';
import { apiService } from '../../service/api.service'; 
import { ModalCambiarFotoperfilComponent } from '../jardin/components/dialogs/modal-cambiar-fotoperfil/modal-cambiar-fotoperfil.component';
import { ModalCambiarPassComponent } from '../jardin/components/dialogs/modal-cambiar-pass/modal-cambiar-pass.component';
import { Region } from 'src/app/model/Cuentas.model';

@Component({
  selector: 'app-administrador-regional',
  templateUrl: './administrador-regional.component.html',
  styleUrls: ['./administrador-regional.component.css']
})
export class AdministradorRegionalComponent implements OnInit {

  region:Region;
  menuMostrar = "inicio";
  cargando = false; 
  tutor:Tutor;
  idUsuario='';
  urlProfile = '';

  
  constructor(
    public api: apiService,
    public storageService: StorageService,
    public dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.idUsuario = this.storageService.getCurrentUser().idUsuario.toString();
    this.getRegionByIdUsuario();
    this.getFotoPerfil();
    this.menuMostrar = this.storageService.getMenuActivo() != null ? this.storageService.getMenuActivo() : 'pei-inicio-view' ;
  }
    
  getRegionByIdUsuario(){
    this.api.API_GET_getRegionByIdUsuario(this.idUsuario).subscribe((response:any) => {
     this.region = response.payload;
    },
    (err) => { 
      console.log(err)
    })
  }


  getFotoPerfil() {
    this.api.API_POST_obtenerFotoPerfil(this.idUsuario).subscribe((response:any) => {
      if(response.payload != null){
        this.urlProfile = "data:image/jpg;base64,"+response.payload;
      }else{
        this.urlProfile = "../../../assets/JUNJI_avatar.svg";
      }
      
    },
    (err) => { 
      this.urlProfile = "../../../assets/JUNJI_avatar.svg";
      console.log(err)
    })
  }


  menuVisible(item) {
    this.storageService.setMenuActivo(item);
    this.menuMostrar = this.storageService.getMenuActivo();
  }

  cambiarPass(){ 
    const dialogRef = this.dialog.open(ModalCambiarPassComponent, { disableClose: true }); 
    dialogRef.afterClosed().subscribe(result => { 
      if(result=='refresh'){
      

      }
    });
  }

  cambiarFoto(){
    const dialogRef = this.dialog.open(ModalCambiarFotoperfilComponent, { disableClose: true }); 
    dialogRef.afterClosed().subscribe(result => {
      this.ngOnInit();
    });
  }



  cerrarSesion(){
    this.storageService.logout();
  }


}
